/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedComponentShowcaseRouteImport } from './routes/_authenticated/component-showcase'
import { Route as AuthenticationLoginRouteImport } from './routes/authentication/login'
import { Route as AuthenticationResetPasswordRouteImport } from './routes/authentication/reset-password'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedCustomersSearchRouteImport } from './routes/_authenticated/customers/search'
import { Route as AuthenticatedPayeePendingApprovalRouteImport } from './routes/_authenticated/payee/pending-approval'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedUsersNewRouteImport } from './routes/_authenticated/users/new'
import { Route as AuthenticationCustomerSignUpTokenRouteImport } from './routes/authentication/customer-sign-up/$token'
import { Route as AuthenticatedCustomersCustomerIdIndexRouteImport } from './routes/_authenticated/customers/$customerId/index'
import { Route as AuthenticatedCustomersCustomerIdDetailRouteImport } from './routes/_authenticated/customers/$customerId/detail'
import { Route as AuthenticatedPayeePendingApprovalPayeeIdRouteImport } from './routes/_authenticated/payee/pending-approval_.$payeeId'
import { Route as AuthenticatedCustomersCustomerIdPayeeNewRouteImport } from './routes/_authenticated/customers/$customerId/payee/new'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedComponentShowcaseRoute =
  AuthenticatedComponentShowcaseRouteImport.update({
    id: '/component-showcase',
    path: '/component-showcase',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticationLoginRoute = AuthenticationLoginRouteImport.update({
  id: '/authentication/login',
  path: '/authentication/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticationResetPasswordRoute =
  AuthenticationResetPasswordRouteImport.update({
    id: '/authentication/reset-password',
    path: '/authentication/reset-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersSearchRoute =
  AuthenticatedCustomersSearchRouteImport.update({
    id: '/customers/search',
    path: '/customers/search',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPayeePendingApprovalRoute =
  AuthenticatedPayeePendingApprovalRouteImport.update({
    id: '/payee/pending-approval',
    path: '/payee/pending-approval',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersNewRoute = AuthenticatedUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticationCustomerSignUpTokenRoute =
  AuthenticationCustomerSignUpTokenRouteImport.update({
    id: '/authentication/customer-sign-up/$token',
    path: '/authentication/customer-sign-up/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedCustomersCustomerIdIndexRoute =
  AuthenticatedCustomersCustomerIdIndexRouteImport.update({
    id: '/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersCustomerIdDetailRoute =
  AuthenticatedCustomersCustomerIdDetailRouteImport.update({
    id: '/customers/$customerId/detail',
    path: '/customers/$customerId/detail',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPayeePendingApprovalPayeeIdRoute =
  AuthenticatedPayeePendingApprovalPayeeIdRouteImport.update({
    id: '/payee/pending-approval_/$payeeId',
    path: '/payee/pending-approval/$payeeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersCustomerIdPayeeNewRoute =
  AuthenticatedCustomersCustomerIdPayeeNewRouteImport.update({
    id: '/customers/$customerId/payee/new',
    path: '/customers/$customerId/payee/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/component-showcase': typeof AuthenticatedComponentShowcaseRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/customers/search': typeof AuthenticatedCustomersSearchRoute
  '/payee/pending-approval': typeof AuthenticatedPayeePendingApprovalRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/authentication/customer-sign-up/$token': typeof AuthenticationCustomerSignUpTokenRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/customers/$customerId/detail': typeof AuthenticatedCustomersCustomerIdDetailRoute
  '/payee/pending-approval/$payeeId': typeof AuthenticatedPayeePendingApprovalPayeeIdRoute
  '/customers/$customerId/': typeof AuthenticatedCustomersCustomerIdIndexRoute
  '/customers/$customerId/payee/new': typeof AuthenticatedCustomersCustomerIdPayeeNewRoute
}
export interface FileRoutesByTo {
  '/component-showcase': typeof AuthenticatedComponentShowcaseRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/': typeof AuthenticatedIndexRoute
  '/customers/search': typeof AuthenticatedCustomersSearchRoute
  '/payee/pending-approval': typeof AuthenticatedPayeePendingApprovalRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/authentication/customer-sign-up/$token': typeof AuthenticationCustomerSignUpTokenRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/customers/$customerId/detail': typeof AuthenticatedCustomersCustomerIdDetailRoute
  '/payee/pending-approval/$payeeId': typeof AuthenticatedPayeePendingApprovalPayeeIdRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdIndexRoute
  '/customers/$customerId/payee/new': typeof AuthenticatedCustomersCustomerIdPayeeNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/component-showcase': typeof AuthenticatedComponentShowcaseRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/customers/search': typeof AuthenticatedCustomersSearchRoute
  '/_authenticated/payee/pending-approval': typeof AuthenticatedPayeePendingApprovalRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/users/new': typeof AuthenticatedUsersNewRoute
  '/authentication/customer-sign-up/$token': typeof AuthenticationCustomerSignUpTokenRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/customers/$customerId/detail': typeof AuthenticatedCustomersCustomerIdDetailRoute
  '/_authenticated/payee/pending-approval_/$payeeId': typeof AuthenticatedPayeePendingApprovalPayeeIdRoute
  '/_authenticated/customers/$customerId/': typeof AuthenticatedCustomersCustomerIdIndexRoute
  '/_authenticated/customers/$customerId/payee/new': typeof AuthenticatedCustomersCustomerIdPayeeNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/component-showcase'
    | '/authentication/login'
    | '/authentication/reset-password'
    | '/customers/search'
    | '/payee/pending-approval'
    | '/users/$userId'
    | '/users/new'
    | '/authentication/customer-sign-up/$token'
    | '/customers/'
    | '/users/'
    | '/customers/$customerId/detail'
    | '/payee/pending-approval/$payeeId'
    | '/customers/$customerId/'
    | '/customers/$customerId/payee/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/component-showcase'
    | '/authentication/login'
    | '/authentication/reset-password'
    | '/'
    | '/customers/search'
    | '/payee/pending-approval'
    | '/users/$userId'
    | '/users/new'
    | '/authentication/customer-sign-up/$token'
    | '/customers'
    | '/users'
    | '/customers/$customerId/detail'
    | '/payee/pending-approval/$payeeId'
    | '/customers/$customerId'
    | '/customers/$customerId/payee/new'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/component-showcase'
    | '/authentication/login'
    | '/authentication/reset-password'
    | '/_authenticated/'
    | '/_authenticated/customers/search'
    | '/_authenticated/payee/pending-approval'
    | '/_authenticated/users/$userId'
    | '/_authenticated/users/new'
    | '/authentication/customer-sign-up/$token'
    | '/_authenticated/customers/'
    | '/_authenticated/users/'
    | '/_authenticated/customers/$customerId/detail'
    | '/_authenticated/payee/pending-approval_/$payeeId'
    | '/_authenticated/customers/$customerId/'
    | '/_authenticated/customers/$customerId/payee/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthenticationLoginRoute: typeof AuthenticationLoginRoute
  AuthenticationResetPasswordRoute: typeof AuthenticationResetPasswordRoute
  AuthenticationCustomerSignUpTokenRoute: typeof AuthenticationCustomerSignUpTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/component-showcase': {
      id: '/_authenticated/component-showcase'
      path: '/component-showcase'
      fullPath: '/component-showcase'
      preLoaderRoute: typeof AuthenticatedComponentShowcaseRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/authentication/login': {
      id: '/authentication/login'
      path: '/authentication/login'
      fullPath: '/authentication/login'
      preLoaderRoute: typeof AuthenticationLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authentication/reset-password': {
      id: '/authentication/reset-password'
      path: '/authentication/reset-password'
      fullPath: '/authentication/reset-password'
      preLoaderRoute: typeof AuthenticationResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/search': {
      id: '/_authenticated/customers/search'
      path: '/customers/search'
      fullPath: '/customers/search'
      preLoaderRoute: typeof AuthenticatedCustomersSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payee/pending-approval': {
      id: '/_authenticated/payee/pending-approval'
      path: '/payee/pending-approval'
      fullPath: '/payee/pending-approval'
      preLoaderRoute: typeof AuthenticatedPayeePendingApprovalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/new': {
      id: '/_authenticated/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AuthenticatedUsersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/authentication/customer-sign-up/$token': {
      id: '/authentication/customer-sign-up/$token'
      path: '/authentication/customer-sign-up/$token'
      fullPath: '/authentication/customer-sign-up/$token'
      preLoaderRoute: typeof AuthenticationCustomerSignUpTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/customers/$customerId/': {
      id: '/_authenticated/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId/'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$customerId/detail': {
      id: '/_authenticated/customers/$customerId/detail'
      path: '/customers/$customerId/detail'
      fullPath: '/customers/$customerId/detail'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdDetailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payee/pending-approval_/$payeeId': {
      id: '/_authenticated/payee/pending-approval_/$payeeId'
      path: '/payee/pending-approval/$payeeId'
      fullPath: '/payee/pending-approval/$payeeId'
      preLoaderRoute: typeof AuthenticatedPayeePendingApprovalPayeeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$customerId/payee/new': {
      id: '/_authenticated/customers/$customerId/payee/new'
      path: '/customers/$customerId/payee/new'
      fullPath: '/customers/$customerId/payee/new'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdPayeeNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedComponentShowcaseRoute: typeof AuthenticatedComponentShowcaseRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCustomersSearchRoute: typeof AuthenticatedCustomersSearchRoute
  AuthenticatedPayeePendingApprovalRoute: typeof AuthenticatedPayeePendingApprovalRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedUsersNewRoute: typeof AuthenticatedUsersNewRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedCustomersCustomerIdDetailRoute: typeof AuthenticatedCustomersCustomerIdDetailRoute
  AuthenticatedPayeePendingApprovalPayeeIdRoute: typeof AuthenticatedPayeePendingApprovalPayeeIdRoute
  AuthenticatedCustomersCustomerIdIndexRoute: typeof AuthenticatedCustomersCustomerIdIndexRoute
  AuthenticatedCustomersCustomerIdPayeeNewRoute: typeof AuthenticatedCustomersCustomerIdPayeeNewRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedComponentShowcaseRoute: AuthenticatedComponentShowcaseRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCustomersSearchRoute: AuthenticatedCustomersSearchRoute,
  AuthenticatedPayeePendingApprovalRoute:
    AuthenticatedPayeePendingApprovalRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedUsersNewRoute: AuthenticatedUsersNewRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedCustomersCustomerIdDetailRoute:
    AuthenticatedCustomersCustomerIdDetailRoute,
  AuthenticatedPayeePendingApprovalPayeeIdRoute:
    AuthenticatedPayeePendingApprovalPayeeIdRoute,
  AuthenticatedCustomersCustomerIdIndexRoute:
    AuthenticatedCustomersCustomerIdIndexRoute,
  AuthenticatedCustomersCustomerIdPayeeNewRoute:
    AuthenticatedCustomersCustomerIdPayeeNewRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthenticationLoginRoute: AuthenticationLoginRoute,
  AuthenticationResetPasswordRoute: AuthenticationResetPasswordRoute,
  AuthenticationCustomerSignUpTokenRoute:
    AuthenticationCustomerSignUpTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
